<template>
<div v-if="loading" class="over container">
    <div class="row" style="height: 45vh">
        <div class="col-12"></div>
    </div>
    <div class="row">
        <div class="spinner-border text-primary center" role="status">
            <span class="sr-only"></span>
        </div>
    </div>
</div>
<!-- <div v-else class="container mt-0 background"> -->
<!-- *************************SHOW SPECIFIC INFO PAGE********************************* -->

<!-- <div class="over fadeIn" id="specificInfoPage"  v-else> -->
<div class="fadeIn" id="specificInfoPage" v-else-if="specificItemDetails" :class="{ ltr: isEnglish }">

    <PointNumberLine style="position: relative; top: 0px;" :point-number="pointNumber" />

    <!-- <div class="closingCross" @click="closeSpeciticInfo" style="z-index: 10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
          style="color: black; position: relative; font-size: 16px"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          />
        </svg>
      </div> -->
    <div class="row" style="background: #63C4C3; position: relative; bottom: 2px;">
        <div class="col-6 presented mb-2"></div>
        <div class="closingCross col-6" @click="closeSpeciticInfo" :class="{ alignRight: isEnglish }">
            {{ translation.backToList }}

            <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
            </svg>
        </div>
    </div>
    <div class="row" style="position: relative; bottom: 3px;">
        <div class="col-12" style="background-color: #63C4C3;">
            <div class="title">
                {{ specificItemDetails.nameToShow }}
            </div>
            <img :src="specificItemDetails.imageToShow" alt="" style="max-width: 200px; display: block; margin: 5% auto" />
        </div>
        <div class="col-12 justify-content-bottom align-self-end" style="
            color: grey;
            text-align: right;
            padding: 25px 35px;
            overflow: auto;
            padding: 20px 42px;
          "
          :class="{ ltr: isEnglish }">
            <!-- <div class="title">
                    {{ specificItemDetails.nameToShow }}
                </div> -->
            <div v-if="specificItemDetails.nameToShow == 'גרעין, להב וחוד'">
                <img src="../../static/img/Levallois.gif" alt="" style="height: 100%; width: 100%" />
            </div>
            <div class="mt-2">
                {{ specificItemDetails.infoToShow }}
            </div>
            <div class="row mt-2">
                <div class="col-4 subTitle"> {{ translation.place }} :</div>
                <div class="col-8">
                    {{ specificItemDetails.placeToShow }}
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-4 subTitle"> {{ translation.period }} :</div>
                <div class="col-8">
                    {{ specificItemDetails.periodToShow }}
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-4 subTitle">{{ translation.material }} :</div>
                <div class="col-8">
                    {{ specificItemDetails.materialToShow }}
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->
</template>

<script>
import PointNumberLine from "./pointNumberLine";
export default {
    components: {
        PointNumberLine,
    },
    data() {
        return {
            isEnglish: false,
            specificItemDetails: null,
            showMainPage: true,
            style: "",
            showSpecificInfo: false,
            infoToShow: "",
            imageToShow: "",
            periodToShow: "",
            placeToShow: "",
            nameToShow: "",
            materialToShow: "",
            showMoreInfoOfItem: false,
            keyToReRenderAudio: 0,
            showMoreInformation: false,
            index: 0,
            pointNumber: 0,
            translation: {
                backToList: "חזרה לרשימה",
            }
        };
    },
    mounted() {
        if (localStorage.getItem("pointNumber")) {
            this.pointNumber = Number(localStorage.getItem("pointNumber"));
        } else {
            this.pointNumber = 0;
        }
        const saved = localStorage.getItem("specificItemDetails");
        if (saved) {
            this.specificItemDetails = JSON.parse(saved);
        }
        this.translate(this.$store.getters.lang)
        if (this.$store.getters.lang == "en") {
            console.log("isEnglish")
            this.isEnglish = true
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        error() {
            return this.$store.getters.error;
        },
        points() {
            console.log("this.$store.getters.points", this.$store.getters.points);
            return this.$store.getters.points;
        },
        vitrinesMain() {
            return this.$store.getters.vitrinesMain;
        },
        itemsArray() {
            let itemsArray = [];
            this.points.forEach((point) => {
                // console.log("point.vitrine", point.vitrine);
                // console.log("this.index", this.index);

                if (point.vitrine == this.pointNumber + 1) {
                    itemsArray.push(point);
                    console.log("accepted point", point);
                } else {
                    console.log("REJECTED point", point);
                }
            });
            console.log("itemsArray", itemsArray);
            return itemsArray;
        },
    },
    methods: {

        translate(lang) {
            switch (lang) {
                case 'he':
                    this.translation = {
                        backToList: "חזרה לרשימה",
                        place: "אתר",
                        period: "תקופה",
                        material: "חומר"
                    };
                    break;
                case 'ar':
                    this.translation = {
                        backToList: "عودة إلى القائمة",
                        place: "مكان",
                        period: "فترة",
                        material: "مادة"
                    };
                    break;
                case 'en':
                    this.translation = {
                        backToList: "Back to list",
                        place: "Place",
                        period: "Period",
                        material: "Material"
                    };
                    break;
                default:
                    // Handle default case if needed
                    break;
            }
        },
        closeSpeciticInfo() {
            setTimeout(() => {
                this.$router.push({ name: "itemsList" });
            }, 500);
            document.getElementById("specificInfoPage").className = "fadeOut over";
            this.showMoreInformation = true;
            // }
        },

        onDismissed() {
            this.$store.dispatch("clearError");
        },
    },
};
</script>

<style scoped>
.alignRight {
    text-align: right;
}
.ltr {
    direction: ltr;
    text-align: left !important;
}
#specificInfoPage {
    top: -1px;
    position: relative;
}

.title {
    font-size: 30px;
    color: rgb(37, 37, 37);
    font-weight: bold;
    text-align: center;
    color: white;
}

.subTitle {
    font-size: 18px;
    color: rgb(37, 37, 37);
}

.captionArrow {
    position: absolute;
    font-size: 12px;
    top: 23px;
    left: 30px;
}

.audioButton {
    width: 100%;
    border: 2px #79a541 solid;
    border-radius: 25px;
    height: 40px;
    margin-bottom: 16px;
    position: relative;
}

.slideLeft {
    -webkit-animation: slideLeft 0.5s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: slideLeft 0.5s;
    /* Firefox < 16 */
    -ms-animation: slideLeft 0.5s;
    /* Internet Explorer */
    -o-animation: slideLeft 0.5s;
    /* Opera < 12.1 */
    animation: slideLeft 0.5s;
}

.slideRight {
    -webkit-animation: slideRight 0.5s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: slideRight 0.5s;
    /* Firefox < 16 */
    -ms-animation: slideRight 0.5s;
    /* Internet Explorer */
    -o-animation: slideRight 0.5s;
    /* Opera < 12.1 */
    animation: slideRight 0.5s;
}

.navBarTitle {
    position: relative;
    font-size: 22px !important;
    color: black;
    text-align: left;
    width: 100%;
    padding: 10px 18px;
}

.appBackground {
    background: url(../../static/img/appBackground.png) center center;
}

.titleSpan {
    z-index: 30;
    opacity: 1;
    padding: 10px;
    border: solid 1px white;
    width: 180px;
}

.backgroundImage {
    position: relative;
    text-align: center;
    color: white;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.backgroundImage::before {
    content: "";
    position: absolute;
    background-color: black;
    background-blend-mode: screen;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.5;
}


.closingCross {
    position: relative;
    top: 0px;
    right: 18px;
    z-index: 20;
    color: black;
    font-size: 16px;
    z-index: 50;
}

.detectiveName {
    position: relative;
    bottom: 189px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    display: block;
}

.licenceImage {
    width: 100%;
}

.fadeIn {
    -webkit-animation: fadein 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 1s;
    /* Firefox < 16 */
    -ms-animation: fadein 1s;
    /* Internet Explorer */
    -o-animation: fadein 1s;
    /* Opera < 12.1 */
    animation: fadein 1s;
}

.fadeOut {
    -webkit-animation: fadeOut 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadeOut 1s;
    /* Firefox < 16 */
    -ms-animation: fadeOut 1s;
    /* Internet Explorer */
    -o-animation: fadeOut 1s;
    /* Opera < 12.1 */
    animation: fadeOut 1s;
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Internet Explorer */
@-ms-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Firefox < 16 */
@-moz-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideRight {
    from {
        left: 1;
    }

    to {
        left: 100vw;
    }
}

/* Internet Explorer */
@-ms-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Opera < 12.1 */
@-o-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

@keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Firefox < 16 */
@-moz-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Internet Explorer */
@-ms-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Opera < 12.1 */
@-o-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

.imageInput {
    width: 100%;
}

.inputOnImage {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 5px;
    left: 5px;
    text-align: center;
}

.topSecret {
    position: absolute;
    bottom: -30px;
    left: -37px;
    width: 248px;
}

.roundButton {
    height: 48px !important;
    width: 128px;
    border: black solid 1px;
    color: black;
    border-radius: 5px;
    background: white;
    font-size: 18px;
}

.inputSecretCode {
    width: 40px;
}

.stopButton {
    border-radius: 10px;
    background-color: rgb(183 26 5);
    margin-top: 30px;
    font-size: 24px;
    height: 50px;
    width: 50px;
    border: solid 2px white;
}

.recButton {
    border-radius: 50px;
    background-color: rgb(183 26 5);
    margin-top: 30px;
    font-size: 24px;
    height: 50px;
    width: 50px;
    border: solid 15px white;
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        border: solid 10px white;
    }
}

.green {
    border: solid 5px #05e01c !important;
}

.image {
    width: 100%;
}

#timer {
    height: 62px;
    background: brown;
    padding-top: 11px;
    color: white;
    margin: 0;
}

.background {
    background-color: white;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.myModal {
    width: 320px;
    border-radius: 10px;
    display: block;
    margin: 0px auto;
    background-color: white;
}

.over {
    /* position: absolute;
  top: 50px; */
    font-size: 18px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: block;
    margin: 0px auto;
    background: white;
}

.center {
    display: block;
    margin: 0px auto;
}

.colorBtn {
    border-radius: 36px;
    min-height: 56px;
    color: white;
}

.fullWidth {
    width: 95%;
    display: block;
    margin: 0px auto;
}

.container {
    margin-top: 16px;
    font-size: 20px;
    /* min-height: 100vh; */
}
</style>
